const $ = require('jquery');
const $S = require('scriptjs');
const centermap = {lat: 50.795420, lng: 4.330551};
const markermap = {lat: 50.795420, lng: 4.330551};

module.exports = {
    init: () => {

    	if ($('#js-map').length > 0)
    	{
	    	function initMap() {
				map = new google.maps.Map(document.getElementById('js-map'), {
				  center: centermap,
				  zoom: 14,
				  styles: styles
				});

				const marker = new google.maps.Marker({
					position: markermap,
					map: map,
					icon : '/assets/integration/images/icons/gmap.png'
				});

			}	

			const styles = [{"featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{"color": "#444444"} ] }, {"featureType": "landscape", "elementType": "all", "stylers": [{"color": "#f2f2f2"} ] }, {"featureType": "poi", "elementType": "all", "stylers": [{"visibility": "off"} ] }, {"featureType": "road", "elementType": "all", "stylers": [{"saturation": -100 }, {"lightness": 45 } ] }, {"featureType": "road", "elementType": "geometry", "stylers": [{"visibility": "on"}, {"color": "#000000"} ] }, {"featureType": "road", "elementType": "labels.text", "stylers": [{"visibility": "on"}, {"color": "#ffffff"}, {"weight": "2.67"} ] }, {"featureType": "road", "elementType": "labels.text.fill", "stylers": [{"visibility": "on"}, {"color": "#ffffff"} ] }, {"featureType": "road", "elementType": "labels.text.stroke", "stylers": [{"visibility": "on"}, {"color": "#000000"} ] }, {"featureType": "road", "elementType": "labels.icon", "stylers": [{"visibility": "off"} ] }, {"featureType": "road.highway", "elementType": "all", "stylers": [{"visibility": "simplified"} ] }, {"featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{"visibility": "off"} ] }, {"featureType": "transit", "elementType": "all", "stylers": [{"visibility": "off"} ] }, {"featureType": "water", "elementType": "all", "stylers": [{"color": "#46bcec"}, {"visibility": "on"} ] } ];

	        $S('https://maps.googleapis.com/maps/api/js?key=AIzaSyBesy58zn9qahcAwb0aEdGkytarjU7Fk_4', initMap);	
    	}
    },
};

